import { Alert, Stack, Typography } from '@mui/material';

import { ArrowRightIcon } from '@/components/icons/ArrowRightIcon';
import { Stars01FilledIcon } from '@/components/icons/Stars01FilledIcon';
import { LargeChatComposer } from '@/modules/common/Chat/components/LargeChatComposer';
import { SelectedTemplate } from '@/modules/common/Chat/components/SelectedTemplate';
import { COLORS } from '@/styles/tokens/colors';

import { useArtifactStudioContext } from '../../contexts/artifactStudio.context';
import { TEMPLATE_DETAILS } from '../../DiagramBuilder.constants';
import { ArtifactTemplates } from './ArtifactTemplates';
import { DiagramReferenceImage } from './DiagramReferenceImage';

export function ArtifactComposer() {
  const {
    prompt,
    setPrompt,
    selectedTemplate,
    setSelectedTemplate,
    referenceImage,
    setReferenceImage,
    isValidatingReferenceImage,
    setIsValidatingReferenceImage,
    referenceImageError,
    setReferenceImageError,
    canCreateArtifact,
    createArtifact,
  } = useArtifactStudioContext();

  return (
    <>
      <Stack
        spacing={1}
        sx={{ '& .MuiInputBase-input': (theme) => theme.typography['body-s'] }}
      >
        <Typography variant="title-m" component="h2">
          What do you want to create?
        </Typography>
        <LargeChatComposer
          value={prompt}
          onValueChange={setPrompt}
          onSubmit={createArtifact}
          allowEmptySubmit={Boolean(selectedTemplate)}
          submitDisabled={!canCreateArtifact || isValidatingReferenceImage}
          autoFocusOnMount={false}
          emphasized={Boolean(selectedTemplate)}
          leadingAction={
            selectedTemplate && (
              <SelectedTemplate
                title={TEMPLATE_DETAILS[selectedTemplate].title}
                onRemove={() => setSelectedTemplate(null)}
              />
            )
          }
          trailingActionGap={1}
          trailingAction={
            <DiagramReferenceImage
              file={referenceImage}
              disabled={Boolean(selectedTemplate)}
              onChange={setReferenceImage}
              onErrorChange={setReferenceImageError}
              onValidatingChange={setIsValidatingReferenceImage}
            />
          }
          inputLabel="Describe your artifact"
          placeholder="Create a beneficiary distribution plan for the family trust"
          buttonLabel="Create"
          buttonVariant="prominent"
          buttonEndIcon={ArrowRightIcon}
          inputStartAdornment={
            <Stars01FilledIcon size={16} color={COLORS.BRAND.ORANGE} />
          }
        />
        {referenceImageError && (
          <Alert severity="error">{referenceImageError}</Alert>
        )}
      </Stack>
      <ArtifactTemplates />
    </>
  );
}
